import React, { Children } from 'react'

import styles from './HeaderBar.module.css'

const HeaderBarContainer = ({ ...rest }) => {
  return <div className={styles.container} />
}

export default HeaderBarContainer



// WEBPACK FOOTER //
// ./src/components/header/HeaderBar.js